import * as rules from 'vee-validate/dist/rules.umd.js'
import maxDate from './maxDate'
import validDate from './validDate'
import pin from './pin'
import localBankAccount from './localBankAccount'
import iban from './iban'
import currency from './currency'
import minValue from './minValue'
import maxValue from './maxValue'
import noDecimals from './noDecimals'

const newRules = Object.assign({}, rules)
newRules.max_date = maxDate
newRules.valid_date = validDate
newRules.pin = pin
newRules['local-bank-account'] = localBankAccount
newRules.iban = iban
newRules.currency = currency
newRules.min_value = minValue
newRules.max_value = maxValue
newRules.no_decimals = noDecimals

export default newRules
